"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCaptchaInterceptor = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const selectors_1 = require("../../providers/captcha/selectors");
const PROTECTED_ENDPOINTS = ['/profiles/current/password'];
const getIsProtectedEndpoint = (url) => {
    return PROTECTED_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};
const addCaptchaInterceptor = (axiosInstance, store) => {
    axiosInstance.interceptors.request.use((config) => {
        try {
            if (config.url !== undefined && getIsProtectedEndpoint(config.url)) {
                const state = store.getState();
                const activeCaptchaProvider = (0, selectors_1.selectActiveCaptchaProvider)(state);
                if (activeCaptchaProvider !== '') {
                    let captchaInfo;
                    const captchaProvider = (0, selectors_1.selectCaptchProviderByType)(state, activeCaptchaProvider);
                    switch (activeCaptchaProvider) {
                        case betweb_openapi_axios_1.CaptchaProviderType.Google: {
                            captchaInfo = (0, selectors_1.selectGoogleCaptchaInfo)(state);
                            break;
                        }
                        case betweb_openapi_axios_1.CaptchaProviderType.Yandex: {
                            captchaInfo = (0, selectors_1.selectYandexCaptchaInfo)(state);
                            break;
                        }
                        case betweb_openapi_axios_1.CaptchaProviderType.Huawei: {
                            captchaInfo = (0, selectors_1.selectHuaweiCaptchaInfo)(state);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    if (captchaInfo !== undefined && captchaProvider !== undefined) {
                        if (config.headers === undefined) {
                            config.headers = {};
                        }
                        config.headers['X-Captcha-Provider-Code'] = captchaProvider.code;
                        config.headers['X-Captcha-Data'] = JSON.stringify(captchaInfo);
                    }
                }
            }
            return config;
        }
        catch (e) {
            return config;
        }
    }, (error) => __awaiter(void 0, void 0, void 0, function* () {
        return yield Promise.reject(error);
    }));
};
exports.addCaptchaInterceptor = addCaptchaInterceptor;
//# sourceMappingURL=addCaptchaInterceptor.js.map